<template>
  <div class="form-group">
    <div
      :class="
        !group.title && !group.description
          ? null
          : level === 1
          ? 'mt-3 mb-5'
          : 'mb-2'
      "
    >
      <label
        v-if="group.title"
        :class="
          `form-group__title d-flex align-items-center mb-1 --level-${level}`
        "
        data-cy="form-label"
      >
        {{ group.title }}
      </label>

      <p
        v-if="group.description"
        :class="[
          { 'text-x-small': level && level > 1 },
          'text-grey-60 form-field__description mt-0'
        ]"
        data-cy="form-description"
      >
        {{ group.description }}
      </p>
    </div>

    <template v-if="isPresent(group.form_groups)">
      <form-group
        v-for="childGroup in group.form_groups"
        :key="childGroup.id"
        :group="childGroup"
        :values="values"
        :level="level + 1"
        :is-missable="isMissable"
        @input="vs => $emit('input', vs)"
      />
    </template>
    <div
      v-if="isPresent(group.form_fields)"
      :class="[
        'form-group__fields',
        { '--is-missable': isMissable && group.is_missable }
      ]"
    >
      <form-field
        v-for="(field, index) in group.form_fields"
        class="mb-3"
        :key="index"
        :field="field"
        :value="values[field.id]"
        :is-missed="isMissed"
        :is-missable="isMissable && index === 0 && group.is_missable"
        @input="value => updateFormSubmissionValue(field, value)"
        @miss="miss"
      />
    </div>
  </div>
</template>

<script>
import FormField from "@/components/FormField"

import { isPresent } from "@/lib/utils"
import { MISSED_VALUE } from "@/lib/form-utils"

export default {
  name: "FormGroup",

  components: {
    FormField
  },

  props: {
    group: { type: Object, required: true },
    values: { type: Object, required: true },
    level: { type: Number, default: 1 },
    isMissable: { type: Boolean, default: false }
  },

  model: {
    prop: "values",
    event: "input"
  },

  computed: {
    isMissed() {
      return this.fields.every(
        field => this.values[field.id]?.value === MISSED_VALUE
      )
    },

    fields() {
      return this.group.form_fields
    }
  },

  methods: {
    isPresent,

    updateFormSubmissionValue(field, data) {
      this.$emit("input", {
        ...this.values,
        [field.id]: data
      })
    },

    miss(isMissed) {
      const groupFieldValues = this.fields.reduce((acc, field) => {
        acc[field.id] = {
          ...this.values[field.id],
          value: isMissed ? MISSED_VALUE : field.default_value
        }
        return acc
      }, {})

      this.$emit("input", {
        ...this.values,
        ...groupFieldValues
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.form-group__title {
  font-size: 1rem;
  font-weight: bold;

  &.--level-1 {
    font-size: 1.625rem;
  }

  &.--level-2 {
    font-size: 1.25rem;
  }
}

.form-group__miss {
  position: absolute;
  right: 0;
  bottom: 0;
}

.form-group__fields {
  &.--is-missable {
    margin-top: -0.75rem;
  }

  .form-field:last-child {
    margin-bottom: $size--6;
  }
}
</style>
